import { DEFAULT_PROFILE_IMAGE } from "@outschool/media-urls";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { FilestackImage } from "@outschool/ui-components-shared";
import { Avatar } from "@outschool/ui-legacy-component-library";
import React from "react";

type ParentImageProps = Omit<
  React.ComponentProps<typeof FilestackImage>,
  "alt" | "as" | "imageHeight" | "imageWidth" | "size" | "src" | "sx"
> & {
  size?: number;
  sx?: React.ComponentProps<typeof FilestackImage>["sx"];
  user?: {
    photo?: string | null;
  } | null;
};

export default function ParentImage({
  user,
  size = 125,
  sx,
  ...props
}: ParentImageProps) {
  const src = user && user.photo ? user.photo : DEFAULT_PROFILE_IMAGE;

  return (
    <FilestackImage
      as={Avatar}
      src={src}
      imageWidth={size}
      imageHeight={size}
      size={size}
      sx={{
        flexShrink: 0,
        ...sx,
      }}
      alt=""
      {...props}
    />
  );
}
